import AspectRatioContainer from 'components/generic/AspectRatioContainer/AspectRatioContainer';
import VideoPlayer from 'components/video/VideoPlayer';
import VideoPlaylistPlayer from 'components/video/VideoPlaylistPlayer';
import { Item } from 'react-photoswipe-gallery';
import styled from 'styled-components';
import type { VideoMediaItem } from '../../shared/types';
import { PreviewItem } from 'components/GalleryMediaPreviewer/shared/styles';
import GalleryVideoPlayer from './components/GalleryVideoPlayer';

const StyledAspectRatioContainer = styled(AspectRatioContainer)`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
`;

export default function PreviewGalleryVideoItem({ videoItem, ...restProps }: { videoItem: VideoMediaItem }) {
    const { video } = videoItem;
    const { isVideoly, autoplayVideos } = video;
    const hasAutoPlayVideos = autoplayVideos?.length;

    return (
        <Item
            {...restProps}
            content={
                <StyledAspectRatioContainer maxWidth="800px" ratioHeight={16} ratioWidth={9}>
                    {hasAutoPlayVideos ? (
                        <VideoPlaylistPlayer video={video} />
                    ) : (
                        <GalleryVideoPlayer video={video} playing={!isVideoly} />
                    )}
                </StyledAspectRatioContainer>
            }
        >
            {({ ref, open }) => (
                <PreviewItem ref={ref} onClick={open}>
                    {hasAutoPlayVideos ? (
                        <VideoPlaylistPlayer video={video} width="100%" height="100%" playing={false} />
                    ) : (
                        <VideoPlayer video={video} width="100%" height="100%" playing={false} />
                    )}
                </PreviewItem>
            )}
        </Item>
    );
}
